var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrap",staticClass:"self-service-btn-text",class:{ 'is-marquee': _vm.needMarquee }},[_c('span',{ref:"textEl",staticClass:"self-service-btn-text-inner",style:(_vm.marqueeStyle)},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }